const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentHeroHomepage extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {
		if (this.initialized) {
			return;
		}
		if (this.videoElement && this.videoPlayPauseElement) {
			this.videoPlayPauseElement.addEventListener('click', this.toggleVideoPlayback);
		}
		if (this.scrollDownElement) {
			this.scrollDownElement.addEventListener('click', this.scrollDown);
		}
		this.initialized = true;
	}

	get videoElement() {
		return this.querySelector('.component-hero-homepage__video');
	}

	get videoPlayPauseElement() {
		return this.querySelector('.component-hero-homepage__play-pause');
	}

	get isVideoPlaying() {
    return (this.videoElement
    && this.videoElement.currentTime > 0
    && this.videoElement.paused == false
    && this.videoElement.ended == false);
  }

	pauseVideo() {
    if (this.videoElement) {
      this.videoElement.pause();
      this.videoPlayPauseElement.setAttribute('data-icon', 'play');
      this.videoPlayPauseElement.setAttribute('aria-label', 'play video');
    }
  }

  playVideo() {
    if (this.videoElement) {
      this.videoElement.play();
      this.videoPlayPauseElement.setAttribute('data-icon', 'pause');
      this.videoPlayPauseElement.setAttribute('aria-label', 'pause video');
    }
  }

	toggleVideoPlayback = () => {
    if (this.videoElement) {
      if (this.isVideoPlaying) {
        this.pauseVideo();
      }
      else {
        this.playVideo();
      }
    }
  }

	get scrollDownElement() {
		return this.querySelector('.component-hero-homepage__scroll-down');
	}

	scrollDown = () => {
		if (this.nextElementSibling) {
			this.nextElementSibling.scrollIntoView({behavior: 'smooth'});
			this.scrollDownElement.blur();
		}
	}

}

customElements.define('component-hero-homepage', ComponentHeroHomepage, {extends: 'div'});